import api from "../config/api";

export const getSettings = async () => {
  const res = await api.get("/appSettings/");
  return res.data?.data ?? [];
};

export const saveAppSetting = async (data) => {
  const res = await api.post("/appSettings/", data, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};
